if (!customElements.get("product-taie-bundle-form")) {
  customElements.define(
    "product-taie-bundle-form",
    class ProductTaieBundleForm extends HTMLElement {
      constructor() {
        super();
        this.mainProductVaraintId = this.dataset.id;
        this.maxNumber = this.dataset.maxproduct;
        this.maxfreeProduct = this.dataset.maxfreeproduct;
        this.enableFreeProduct = this.dataset.freeproductenabled;
        this.enabledofferet = this.dataset.enabledofferet;
        this.enabledofferetProducts = this.dataset.offeretproducts;
        this.quantityCounter = 0;
        this.freeQuantityCounter = 0;
        this.selectedBundleAddons = [];
        this.selectedFreeBundleAddons = [];
        
        this.form = this.querySelector("form");
        this.hideErrors = this.dataset.hideErrors === "true";
        this.optionSelectors = this.querySelectorAll(
          `.custom-swatch[data-last="false"] .mark_me-custom-bundle`
        );
        this.bunldeItems = this.querySelectorAll(".bundle-product-setp-wrapper .taie-bunlde-item-main");
        this.bunldeFreeeItems = this.querySelectorAll(".bundle-free-product-setp-wrapper .taie-bunlde-item-main");
        this.defaultBundleButton = this.querySelector(".custom-bundle-default");
        this.defaultFreeBundleButton = this.querySelector(".custom-bundle-free-default");
        this.singleOptionSelectors = this.querySelectorAll(".custom-variant-trigger-bundle-single");
        this.freeProductVariantSelectors = this.querySelectorAll(".custom-variant-trigger-bundle-single-free");
          
        if(this.enableFreeProduct === 'true'){
          this.stepBackSelector = this.querySelector(".first-step-back");
        }
       

        this.initEventListeners();
      }
      initEventListeners(){
         this.optionSelectors.forEach((el) => {
          el.addEventListener("change", this.onOptionChange.bind(this));
        });
         this.bunldeItems.forEach((el) => {
           el.querySelector("h3").addEventListener("click", this.initAccordian.bind(this));
        });
        this.bunldeFreeeItems.forEach((el) => {
           el.querySelector("h3").addEventListener("click", this.initFreeAccordian.bind(this));
        });
        this.singleOptionSelectors.forEach((el) => {
          el.addEventListener("change", this.onVariantSelect.bind(this));
        });
        this.freeProductVariantSelectors.forEach((el) => {
          el.addEventListener("change", this.onFreeProductVariantSelect.bind(this));
        });
        this.defaultBundleButton.addEventListener("click",this.defaultButtonClickHandle.bind(this));
         if(this.enableFreeProduct === 'true'){
        this.stepBackSelector.addEventListener("click",this.stepBackButtonHandler.bind(this));
            this.defaultFreeBundleButton.addEventListener("click",this.defaultFreeBundleButtonHandler.bind(this));
         }
        
       
      }
      initFreeAccordian(evt){
         const parentElement = evt.target.closest(".taie-bunlde-item-main");
        this.bunldeFreeeItems.forEach((el) => {
          if(el == parentElement){
             el.classList.add("div-opened");
             el.querySelector(".taie-bundle-content").classList.remove("hide");
          }else{
            el.classList.remove("div-opened");
            el.querySelector(".taie-bundle-content").classList.add("hide");
          }
        })
      }
      initAccordian(evt){
         const parentElement = evt.target.closest(".taie-bunlde-item-main");
        this.bunldeItems.forEach((el) => {
          if(el == parentElement){
             el.classList.add("div-opened");
             el.querySelector(".taie-bundle-content").classList.remove("hide");
          }else{
            el.classList.remove("div-opened");
            el.querySelector(".taie-bundle-content").classList.add("hide");
          }
        })
      }
     connectedCallback() {
         this.bunldeItems.forEach( (el) => {
          const firstOption = el.querySelector(`.custom-swatch[data-last="false"] .first-element-option .mark_me-custom-bundle`);
           if(firstOption){
             firstOption.dispatchEvent(new Event('change'));
           }
         });
         this.closest(".custom-modal__centered").classList.add("custom-taie-bundle-enabled");
        let osInstance;
        if(osInstance){
          osInstance.destroy();
        }
        osInstance = OverlayScrollbars(this.querySelectorAll(`.bundle-items-wrapper`),{});   
    
     }

      updateCounter(){
        this.quantityCounter = 0;
        this.quantityCounter = this.querySelectorAll(".bundle-product-setp-wrapper .custom-variant-placement-wrapper .custom-swatch-element.checked-item").length;
        this.selectedBundleAddons = [];
        this.querySelectorAll(".bundle-product-setp-wrapper .custom-variant-placement-wrapper .custom-swatch-element.checked-item").forEach((el) => {
          this.selectedBundleAddons.push({
            id:el.dataset.vid,
            title:el.dataset.vtitle
          });
        });
        this.querySelector(".bundle-counter").textContent = `${this.quantityCounter}/${this.maxNumber}`;
        if(this.quantityCounter == this.maxNumber ){
          if(this.enableFreeProduct === 'true'){
            this.defaultBundleButton.classList.add("next-step-active");
          }else{
            this.defaultBundleButton.classList.add("submit-the-button");
          }
          this.defaultBundleButton.querySelector(".bundle-message").classList.add("hide");
          this.defaultBundleButton.querySelector(".add-to-cart-message").classList.remove("hide");
           if(this.enableFreeProduct === 'true'){
          this.defaultBundleButton.querySelector(".add-to-cart-message-icon").classList.remove("hide");
           }
          this.defaultBundleButton.removeAttribute("disabled");
        }else{
          this.defaultBundleButton.classList.remove("submit-the-button");
          this.defaultBundleButton.classList.remove("next-step-active");
          this.defaultBundleButton.querySelector(".bundle-message").classList.remove("hide");
          this.defaultBundleButton.querySelector(".add-to-cart-message").classList.add("hide");
           if(this.enableFreeProduct === 'true'){
          this.defaultBundleButton.querySelector(".add-to-cart-message-icon").classList.add("hide");
           }
          this.defaultBundleButton.setAttribute("disabled","disabled");
        }
      }

       updateFreeCounter(){
        this.freeQuantityCounter = 0;
        this.freeQuantityCounter = this.querySelectorAll(".bundle-free-product-setp-wrapper .custom-variant-placement-wrapper .custom-swatch-element.checked-item").length;
        this.selectedFreeBundleAddons = [];
        this.querySelectorAll(".bundle-free-product-setp-wrapper .custom-variant-placement-wrapper .custom-swatch-element.checked-item").forEach((el) => {
          this.selectedFreeBundleAddons.push(
            {
            id:el.dataset.vid,
            title:el.dataset.vtitle
          }
          );
        });
        this.querySelector(".bundle-counter-free").textContent = `${this.freeQuantityCounter}/${this.maxfreeProduct}`;
        if(this.freeQuantityCounter == this.maxfreeProduct ){
          this.defaultFreeBundleButton.classList.add("submit-the-free-button");
          this.defaultFreeBundleButton.querySelector(".bundle-message").classList.add("hide");
          this.defaultFreeBundleButton.querySelector(".add-to-cart-message").classList.remove("hide");
          this.defaultFreeBundleButton.removeAttribute("disabled");
        }else{
          this.defaultFreeBundleButton.classList.remove("submit-the-free-button");
          this.defaultFreeBundleButton.querySelector(".bundle-message").classList.remove("hide");
          this.defaultFreeBundleButton.querySelector(".add-to-cart-message").classList.add("hide");
          this.defaultFreeBundleButton.setAttribute("disabled","disabled");
        }
      }

      onOptionChange(evt) {
        const mainElement = evt.target.closest(".custom-swatches-bundle-new");
        const selectedValue = evt.target.value;
        const selectedTitle = evt.target.dataset.value;
        const currentWrapper = evt.target.closest(".custom-swatch");
         evt.target.closest(".taie-bunlde-item-main").classList.remove("selectedbox");
        currentWrapper
          .querySelectorAll(".custom-swatch-element")
          .forEach((el) => {
            el.classList.remove("checked-item");
          });
        evt.target.parentElement.classList.add("checked-item");
        mainElement.querySelector(
          ".custom-variant-placement-wrapper"
        ).innerHTML = "";
        const selectedOptions = this.makeOptionSlug(selectedValue, mainElement);
        console.log(selectedOptions,mainElement);
        if (selectedOptions.length > 0) {
          for (let i in selectedOptions) {
            const variantHtml = mainElement
              .querySelector(
                `.varaint-template-data div[data-option="${selectedOptions[i]}"]`
              )
              .cloneNode(true);
            if (variantHtml) {
              mainElement
                .querySelector(".custom-variant-placement-wrapper")
                .appendChild(variantHtml);
            }
          }
          mainElement.querySelector(".custom-variant-placement-wrapper").setAttribute("data-size",mainElement.querySelectorAll(".custom-variant-placement-wrapper .custom-swatch-element").length);
          this.initVariantEvents(mainElement);
        }
        this.updateCounter();
      }
      
      initVariantEvents(mainElement){
         mainElement.querySelectorAll(
          ".custom-variant-placement-wrapper .custom-variant-trigger-bundle"
        ).forEach( (el) =>{
          el.addEventListener("change", this.onVariantSelect.bind(this));
        });
      }
      onVariantSelect(evt){
          const currentWrapper = evt.target.closest(".custom-variant-placement-wrapper");
          currentWrapper
            .querySelectorAll(".custom-swatch-element")
            .forEach((el) => {
              el.classList.remove("checked-item");
            });
          evt.target.parentElement.classList.add("checked-item");
       evt.target.closest(".taie-bunlde-item-main").classList.add("selectedbox");
         this.updateCounter();
      }
      onFreeProductVariantSelect(evt){
        const currentWrapper = evt.target.closest(".custom-variant-placement-wrapper");
          currentWrapper
            .querySelectorAll(".custom-swatch-element")
            .forEach((el) => {
              el.classList.remove("checked-item");
            });
          evt.target.parentElement.classList.add("checked-item");
        evt.target.closest(".taie-bunlde-item-main").classList.add("selectedbox");
        this.updateFreeCounter();
      }
      makeOptionSlug(selectedValue, mainElement) {
        let selectedOptions = [];
        mainElement
          .querySelectorAll(
            `.custom-swatch[data-last="true"] .mark_me-custom-bundle`
          )
          .forEach((el) => {
            selectedOptions.push(`${selectedValue}-${el.value}`);
          });
        return selectedOptions;
      }

      defaultButtonClickHandle(evt){
        evt.preventDefault();
        if(this.defaultBundleButton.classList.contains("next-step-active")){
          this.querySelector(".bundle-product-setp-wrapper").classList.add("hide");
          this.querySelector(".bundle-free-product-setp-wrapper").classList.remove("hide");
          let osInstance;
          if(osInstance){
            osInstance.destroy();
          }
          osInstance = OverlayScrollbars(this.querySelectorAll(`.bundle-items-wrapper`),{});  
        }else{
          this.submitBundleItems();
        }  
      }
      defaultFreeBundleButtonHandler(evt){
         evt.preventDefault();
         if(this.defaultFreeBundleButton.classList.contains("submit-the-free-button")){
           this.submitBundleItems();
         }
        
      }
      submitBundleItems(){
        if(this.selectedBundleAddons.length <= 0 ){
          return false;
        }
        const bundleId = new Date().getTime();      
        let items = [];
        let allproperties = [];
        let bundlerItem = 0;
        for(let i in this.selectedBundleAddons){
          if(this.selectedBundleAddons[i]){
            allproperties.push(this.selectedBundleAddons[i].title);
            items.push({
              "id":this.selectedBundleAddons[i].id,
              "quantity":1,
              "properties":{
                "_customBundleId":bundleId,
                "_isMainProduct":0,
                "_baseQty":1,
              }
            });
            bundlerItem++;
          }
        }
        for(let i in this.selectedFreeBundleAddons){
          if(this.selectedFreeBundleAddons[i]){
            allproperties.push(this.selectedFreeBundleAddons[i].title);
            items.push({
              "id":this.selectedFreeBundleAddons[i].id,
              "quantity":1,
              "properties":{
                "_customBundleId":bundleId,
                "_isMainProduct":0,
                "_baseQty":1,
                "_isFreeAddon":1
              }
            });
            bundlerItem++;
          }
        }
        if( this.enabledofferet === 'true'){
          if(this.enabledofferetProducts){
            const enabledofferetProductsdata = this.enabledofferetProducts.split("___");
            if(enabledofferetProductsdata.length > 0){
              for(let i in enabledofferetProductsdata){
                if(enabledofferetProductsdata[i]){
                  const slitthestring = enabledofferetProductsdata[i].split("||");
                  let productTitle = slitthestring[1];
                  if(slitthestring[2]){
                    if(slitthestring[2].indexOf("Default") > -1){
                    }else{
                      productTitle = `${productTitle}:${slitthestring[2]}`
                    }
                  }
                  allproperties.push(productTitle);
                  items.push({
                    "id":slitthestring[0],
                    "quantity":1,
                    "properties":{
                      "_customBundleId":bundleId,
                      "_isMainProduct":0,
                      "_baseQty":1,
                      "_isOffertAddon":1
                    }
                  });
                }
              }
            }
          }
        }
        items.push(
          {
            "id":this.mainProductVaraintId,
            "quantity":1,
            "properties":{
              "_customBundleId":bundleId,
              "_isMainProduct":1,
              "Contenu":allproperties.join("|")
            }
          }
        );
        let formData = {
         'items':items
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
             $("body").trigger("added.ajaxProduct");
            this.closest(".custom-modal__centered.active").classList.remove("active");
          });
      }
      stepBackButtonHandler(evt){
        this.querySelector(".bundle-product-setp-wrapper").classList.remove("hide");
        this.querySelector(".bundle-free-product-setp-wrapper").classList.add("hide");
        let osInstance;
        if(osInstance){
          osInstance.destroy();
        }
        osInstance = OverlayScrollbars(this.querySelectorAll(`.bundle-items-wrapper`),{});  
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
